var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.groups),function(group,groupIndex){return _c('form-group-store',{key:group.id,attrs:{"path":(_vm.path + "/" + groupIndex),"page-read-only":_vm.pageReadOnly}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }